import { DefaultTheme } from 'styled-components'

const Typography: DefaultTheme['typography'] = {
  caption:
    'font-family: "Roboto";font-weight: 400;font-size: 12px;line-height: 14px;letter-spacing: 0.4;text-transform: "uppercase";',
  body1:
    'font-family: "Roboto";font-weight: 400;font-size: 16px;line-height: 19px;letter-spacing: 0.5px;',
  overline:
    'font-family: "Roboto";font-weight: 400;font-size: 10px;line-height: 12px;letter-spacing: 1.5;text-transform: "uppercase";',
  tab:
    'font-family: "Roboto";font-weight: 400;font-size: 16px;line-height: 19px;letter-spacing: 0.1px;',
  underlined:
    'font-family: "Roboto";font-weight: 400;font-size: 14px;line-height: 16px;letter-spacing: 0.25px;',
  text:
    'font-family: "Roboto";font-weight: 400;font-size: 12px;line-height: 17px;letter-spacing: 0.5px;',
  bottom_navigation:
    'font-family: "Roboto";font-weight: 400;font-size: 10px;line-height: 12px;letter-spacing: 0.1px;',
  button:
    'font-family: "Roboto";font-weight: 500;font-size: 12px;line-height: 25px;letter-spacing: 0.32px;',
  button_text:
    'font-family: "Roboto";font-weight: 400;font-size: 14px;line-height: 25px;',
  subtitle2:
    'font-family: "Roboto";font-weight: 500;font-size: 14px;line-height: 16px;letter-spacing: 0.1px;',
  body2:
    'font-family: "Roboto";font-weight: 400;font-size: 14px;line-height: 18px;letter-spacing: 0.15px;',
  subtitle1:
    'font-family: "Roboto";font-weight: 400;font-size: 16px;line-height: 19px;letter-spacing: 0.15px;',
  h6:
    'font-family: "Roboto";font-weight: 500;font-size: 20px;line-height: 26px;letter-spacing: 0.15px;',
  h5:
    'font-family: "Roboto";font-weight: 400;font-size: 24px;line-height: 31.2px;letter-spacing: 0px;',
  h4:
    'font-family: "Roboto";font-weight: 700;font-size: 34px;line-height: 40px;letter-spacing: 0.25px;',
  h3:
    'font-family: "Roboto";font-weight: 700;font-size: 48px;line-height: 62.4px;letter-spacing: 0px;',
  h2:
    'font-family: "Roboto";font-weight: 300;font-size: 60px;line-height: 70px;letter-spacing: 0.5px;',
  h1:
    'font-family: "Roboto";font-weight: 300;font-size: 96px;line-height: 113px;letter-spacing: 1.px5;',
}

export default Typography
